<template>
  <div>
    <div id="list" v-if="viewType == 'list'">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
                <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                  <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>
                </div>          
                <div class="box-tools">              
                  <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
            </div>        
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:center;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th>Locker No</th>
                    <th>Locker Room Zone</th>
                    <th>Locker Type</th>
                    <th>gender</th>
                    <th>keyNumber</th>
                    <th>remarks</th>
                    <th>status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                    <td style="width:85px;text-align:right;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                      <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a>
                      <a href="#" v-on:click="onDelete(row)" ref="deleteRow" style="padding-right:5px">
                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                      </a>
                    </td>
                    <td>{{ row.lockerNumber }}</td>
                    <td>{{ row.lockerRoomZone }}</td>
                    <td>{{ row.lockerType }}</td>
                    <td>{{ row.gender }}</td>
                    <td>{{ row.keyNumber }}</td>
                    <td>{{ row.remarks }}</td>
                    <td>{{ row.status }}</td>
                    <td hidden>{{ row.id }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                    <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                    Page
                </label>
                <label>
                    <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" type="text" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}                
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                    <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div id="form" v-if="viewType == 'form'">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <!-- <div class="box-header with-border">
                <h3 class="box-title">Horizontal Form</h3>
              </div> -->
              <form @submit.prevent class="form-horizontal">
                <div class="box-body">
                  <div class="form-group">
                    <label for="inputLockerNumber" class="col-sm-2 control-label">Locker Number</label>

                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Locker Number" v-model="formData.lockerNumber">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputLockerRoomZone" class="col-sm-2 control-label">Locker Room Zone</label>

                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Locker Number" v-model="formData.lockerRoomZone">
                    </div>
                  </div>

                     <div class="form-group">
                    <label for="inputlockerType" class="col-sm-2 control-label">Locker Type</label>

                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Locker Number" v-model="formData.lockerType">
                    </div>
                  </div>

                   <div class="form-group">
                    <label for="inputlockerRemark" class="col-sm-2 control-label">Locker Noted</label>

                    <div class="col-sm-10">
                      <textarea :disabled="viewMode == MODE_VIEW"
                        class="form-textarea" id="inputremarks" placeholder="Locker Noted"
                        v-model="formData.remarks">
                    </textarea>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="inputStatusLocker" class="col-sm-2 control-label">Locker Status</label>
                    <label class="radio-inline">
                    <input :disabled="viewMode == MODE_VIEW"
                    type="radio"
                    value="Active"
                    v-model="formData.status">
                    Active
                </label>

                <label class="radio-inline">
                    <input :disabled="viewMode == MODE_VIEW"
                    type="radio"
                    value="Inactive"
                    v-model="formData.status">
                    Inactive
                </label>
                  </div>
                  
                  <input type="hidden" class="form-control" id="inputId" v-model="formData.id">

                    <div class="form-group">

                    <label class="col-sm-2 control-label">
                        Update by
                    </label>
                    <div class="col-sm-10" style="display:flex; align-items:center;">

                      <input
                        :disabled="viewMode == MODE_VIEW"
                        type="date"
                        class="form-control"
                        style="width:180px;"
                        v-model="formData.updateBy">

                      <input
                        :disabled="viewMode == MODE_VIEW"
                        type="text"
                        class="form-control"
                        style="width:220px; margin-left:8px;"
                        v-model="formData.firstName">

                    </div>
                    <!-- <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" type="date" class="form-control" placeholder="Locker Number" v-model="formData.updateBy">
                      <input
                        class="form-input input-medium"
                        style="margin-left:8px"
                        v-model="formData.firstName">
                    </div> -->
                    </div>
                </div>
                <!-- /.box-body -->
                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
                  </div>
                </div>
                <!-- /.box-footer -->
              </form>
            </div>          
          </div>
        </div>
      </div> 
    </transition>  
  </div>  
</template>

<script>
import api from '../../../api'
import SweetAlert from 'sweetalert2'

const VIEW_LIST = 'list'
const VIEW_FORM = 'form'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'Locker',
  data() {
    return {
      VIEW_LIST: VIEW_LIST,
      VIEW_FORM: VIEW_FORM,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      column: '',
      item: null,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name'
      },
      viewType: VIEW_LIST,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        lockerNumber: '',
        lockerRoomZone: '',
        lockerType: 'STANDART',
        gender: 'M',
        keyNumber: '0000',
        remarks: '',
        status: 'Active'
      }
    }
  },
  created() {
    this.viewType = VIEW_LIST
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    inquiry() {
      api
        .request('Golf', 'get', '/api/golf/masters/lockerMaster?limit=' + this.inquiryParam.PageSize + '&page=' + this.inquiryParam.CurrentPageNumber, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.name = ''
    },
    onCreate() {
      this.initForm()
      this.viewType = VIEW_FORM
      this.viewMode = MODE_CREATE
    },
    onDisplay(row) {
      this.viewType = VIEW_FORM
      this.viewMode = MODE_VIEW

      this.formData.id = row.id
      this.formData.name = row.name
    },
    onEdit(data) {
      this.formData.id = data.id
      this.formData.lockerNumber = data.lockerNumber
      this.formData.lockerRoomZone = data.lockerRoomZone
      this.formData.status = data.status
      this.viewType = VIEW_FORM
      this.viewMode = MODE_UPDATE
    },
    onDelete(data) {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.delete(data)
          SweetAlert.fire('Deleted', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.inquiry()
      this.viewType = VIEW_LIST
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        LockerNumber: this.formData.lockerNumber,
        LockerRoomZone: this.formData.lockerRoomZone,
        Status: this.formData.status
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Golf', 'post', '/api/golf/masters/lockerMaster' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity
          this.total = resData.totalRows

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.onDisplay({id: this.formData.id, name: this.formData.name})
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    delete(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id,
        Name: data.name
      }
      api.request('Guest', 'post', '/api/MembershipCategory/Delete', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    }
  }
}
</script>

<style>
/* Hanya style form, tidak memengaruhi list */
#form .box.box-info {
  border: 1px solid #bfd0ea;
  background: rgba(255,255,255,0.2);
  box-shadow: none;
  border-radius: 0;
}

#form .box.box-info .box-body {
  background: rgba(255,255,255,0.08);
  padding: 16px 14px;
}

#form .box.box-info .box-footer {
  background: #e9f0f9;
  border-top: 1px solid #bfd0ea;
  color: #2d405a;
  padding: 12px 14px;
}

#form .form-horizontal {
  width: 100%;
}

#form .form-horizontal .form-group {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 18px;
  width: 100%;
}

#form .form-horizontal .control-label {
  flex: 0 0 180px;
  width: 180px;
  max-width: 180px;
  color: #2d405a;
  font-weight: 700;
  text-align: left;
  padding-top: 8px;
  line-height: 1.3;
  margin: 0;
}

#form .form-horizontal .col-sm-10,
#form .form-horizontal .col-sm-8,
#form .form-horizontal .col-sm-6,
#form .form-horizontal .col-sm-4 {
  flex: 1 1 auto;
  width: 100%;
  min-height: 1px;
  position: static;
  float: none;
  padding-left: 0;
  padding-right: 0;
}

#form .form-horizontal .form-control,
#form .form-horizontal .form-textarea {
  width: 100%;
  height: 38px;
  border: 1px solid #bfd0ea;
  border-radius: 4px;
  background: #fff;
  color: #2d405a;
  box-shadow: none;
  font-size: 14px;
  padding: 8px 10px;
}

#form .form-horizontal .form-textarea {
  min-height: 90px;
  resize: vertical;
}

#form .form-horizontal .radio-inline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #2d405a;
  font-size: 14px;
  margin-right: 18px;
  margin-top: 8px;
}

#form .form-horizontal .radio-inline input {
  width: 18px;
  height: 18px;
  margin: 3;
  accent-color: #1d8ef0;
}

#form .box-tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

#form .box-tools .btn {
  border: 1px solid #b9c7dc;
  background: #f5f7fb;
  color: #2d405a;
  border-radius: 3px;
  padding: 7px 14px;
  font-size: 12px;
}

#form .box-tools .btn-primary,
#form .box-tools .btn-info {
  background: #dfeaf9;
  border-color: #aac0df;
}

#form .box-tools .btn-warning {
  background: #fff2cc;
  border-color: #e5c76e;
  color: #7d5a00;
}

#form .box-tools .btn-default {
  background: #f5f7fb;
}

/* khusus untuk input date + text yang dibuat inline */
#form .form-horizontal [style*="display:flex"] {
  display: flex !important;
  align-items: center;
  gap: 8px;
}

#form .form-horizontal [style*="width:180px;"] {
  width: 180px !important;
}

#form .form-horizontal [style*="width:220px;"] {
  width: 220px !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Locker.vue?4b0a6a4f